import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import dayjs from 'dayjs';
import MandalAdminLayout from "../../../components/MandalAdminLayout/MandalAdminLayout";

function UpdateReport() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [date, setDate] = useState("");
  const [santo1, setSanto1] = useState("");
  const [santo2, setSanto2] = useState("");
  const [agresar, setAgresar] = useState("");
  const [vadlio, setVadlio] = useState(0);
  const [yuvako, setYuvako] = useState(0);
  const [balko, setBalko] = useState(0);
  const [mahilao, setMahilao] = useState(0);
  const [yuvatio, setYuvatio] = useState(0);
  const [balikao, setBalikao] = useState(0);
  const [total, setTotal] = useState(0);
  const [twoWheelers, setTwoWheelers] = useState(0);
  const [fourWheelers, setFourWheelers] = useState(0);
  const [bicycle, setBicycle] = useState(0);
  const [total2, setTotal2] = useState(0);
  const [prasad, setPrasad] = useState("");
  const [phone, setPhone] = useState("");
  const [link, setLink] = useState("");
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { reportId, id } = location?.state || {};
  const currentPath = location?.pathname || "";

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "MandalAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    setTotal(
      Number(vadlio) +
      Number(yuvako) +
      Number(balko) +
      Number(mahilao) +
      Number(yuvatio) +
      Number(balikao)
    );
  }, [vadlio, yuvako, balko, mahilao, yuvatio, balikao]);

  useEffect(() => {
    setTotal2(Number(twoWheelers) + Number(fourWheelers) + Number(bicycle));
  }, [twoWheelers, fourWheelers, bicycle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const config = {
          method: "get",
          url: `${apiURL}/ReportDetails/${reportId}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        };

        const response = await axios.request(config);
        const { data } = response.data;

        setDate(data.date ? dayjs(data.date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"));
        setSanto1(data.santo1);
        setSanto2(data.santo2);
        setAgresar(data.agresar);
        setVadlio(data.vadilo);
        setYuvako(data.yuvako);
        setBalko(data.balko);
        setMahilao(data.mahila);
        setYuvatio(data.yuvti);
        setBalikao(data.balika);
        setTotal(data.total);
        setTwoWheelers(data.twoWheelers);
        setFourWheelers(data.fourWheelers);
        setBicycle(data.bicycle);
        setTotal2(data.total2);
        setPrasad(data.prasad);
        setPhone(data.contactNo);
        setLink(data.link);
      } catch (error) {
        toast.error(error.response.data.message);
      }
    };

    if (reportId) {
      fetchData();
    }
  }, [reportId]);

    useEffect(() => {
      const formattedReport = `
    *Hirawadi Mandal Attendance Report*
    Date: ${date.split("-").reverse().join("-")}
    Santo1: ${santo1}
    Santo2: ${santo2}
    Agreser: ${agresar}
    Vadilo: ${vadlio}
    Yuvako: ${yuvako}
    Balko: ${balko}
    Mahila: ${mahilao}
    Yuvti: ${yuvatio}
    Balika: ${balikao}
    Total: ${total}
      
    *Vehicles*
    Two Wheelers: ${twoWheelers}
    Four Wheelers: ${fourWheelers}
    Bicycle: ${bicycle}
    Total: ${total2}
      
    Prasad: ${prasad}
      `.trim();
  
      const encodedMessage = encodeURIComponent(formattedReport);
      setLink(
        `https://api.whatsapp.com/send/?phone=${phone}&text=${encodedMessage}`
      );
    }, [
      phone,
      date,
      santo1,
      santo2,
      agresar,
      vadlio,
      yuvako,
      balko,
      mahilao,
      yuvatio,
      balikao,
      total,
      twoWheelers,
      fourWheelers,
      bicycle,
      total2,
      prasad,
    ]);

  const handleSubmit = async (e) => {
    setLoaded(true);
    e.preventDefault();

    if (!/^\d{10}$/.test(phone)) {
      setLoaded(false);
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    let data = JSON.stringify({
      id: reportId,
      date: date,
      santo1: santo1,
      santo2: santo2,
      agresar: agresar,
      vadilo: vadlio,
      yuvako: yuvako,
      balko: balko,
      mahila: mahilao,
      yuvti: yuvatio,
      balika: balikao,
      total: total,
      twoWheelers: twoWheelers,
      fourWheelers: fourWheelers,
      bicycle: bicycle,
      total2: total2,
      prasad: prasad,
      contactNo: phone,
      link: link,
      isVisible: true,
    });

    const config = {
      method: "post",
      url: `${apiURL}/ReportDetails/Update`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      const response = await axios.request(config);
      setLoaded(false);
      toast.success(response.data.message);

      if (currentPath === "/update-report2") {
        const timeOutId = setTimeout(() => {
          if (currentPath === "/update-report2") {
            navigate("/sabha-report2");
          }
        }, 3000);
        return () => clearTimeout(timeOutId);
      }
    } catch (error) {
      setLoaded(false);
      toast.error(error.response?.data?.message);
    }
  };

  return (
    <MandalAdminLayout ac3="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">
              <h5>Update Report</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/mandal-admin-dashboard" state={{ id: id }}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/sabha-report2" state={{ id: id }}>Report List</Link>
                </li>
                <li className="breadcrumb-item">Add Report</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportDate">Date</label>
                      <span className="text-danger">*</span>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Date"
                        value={date || ""}
                        onChange={(e) => setDate(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportAgresar">Agresar</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Agresar"
                        value={agresar}
                        onChange={(e) => setAgresar(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportSanto1">Santo 1</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Santo 1"
                        value={santo1}
                        onChange={(e) => setSanto1(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportSanto1">Santo 2</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Santo 2"
                        value={santo2}
                        onChange={(e) => setSanto2(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportVadlio">Vadlio</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Vadlio"
                        value={vadlio}
                        onChange={(e) => setVadlio(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportYuvako">Yuvako</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Yuvako"
                        value={yuvako}
                        onChange={(e) => setYuvako(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportBalko">Balko</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Balko"
                        value={balko}
                        onChange={(e) => setBalko(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportMahilao">Mahilao</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Mahilao"
                        value={mahilao}
                        onChange={(e) => setMahilao(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportYuvatio">Yuvatio</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Yuvatio"
                        value={yuvatio}
                        onChange={(e) => setYuvatio(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportBalikao">Balikao</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Balikao"
                        value={balikao}
                        onChange={(e) => setBalikao(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="haribhaktTotal">Total</label>
                  <span className="text-danger">*</span>

                  <input
                    className="form-control"
                    placeholder="Total"
                    value={total}
                    onChange={(e) => setTotal(e.target.value)}
                    disabled
                    required
                    style={{ cursor: "not-allowed" }}
                  />
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportTwoWheelers">Two Wheelers</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Two Wheelers"
                        value={twoWheelers}
                        onChange={(e) => setTwoWheelers(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportFourWheelers">Four Wheelers</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Four Wheelers"
                        value={fourWheelers}
                        onChange={(e) => setFourWheelers(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportBicycles">Bicycles</label>
                      <span className="text-danger">*</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Bicycles"
                        value={bicycle}
                        onChange={(e) => setBicycle(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportTotal">Total</label>
                      <span className="text-danger">*</span>

                      <input
                        className="form-control"
                        placeholder="Total"
                        value={total2}
                        onChange={(e) => setTotal2(e.target.value)}
                        disabled
                        required
                        style={{ cursor: "not-allowed" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reportPrasad">Prasad</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Prasad"
                        value={prasad}
                        onChange={(e) => setPrasad(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="MobileNumber">Mobile Number</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Mobile Number"
                        value={phone}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhone(value);
                          }
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <div className="float-right">
                    <button
                      type="button"
                      className="btn btn-primary mx-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loaded}
                    >
                      {loaded ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </MandalAdminLayout>
  );
}

export default UpdateReport;
